import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import { Constants } from 'src/app/constants';
import { AccessService } from 'src/app/services/access.service';
import { DataManagementService } from 'src/app/services/data-management.service';
import * as moment from 'moment';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';


@Component({
    selector: 'app-incoming-term-visa-settings',
    templateUrl: './incoming-term-visa-settings.component.html',
    styleUrls: ['./incoming-term-visa-settings.component.css']
})
export class IncomingTermVisaSettingsComponent implements OnInit {

    @ViewChild('addEditIncomingTermVisaSettingsModal') addEditIncomingTermVisaSettingsModal: TemplateRef<any>;
    @ViewChild('viewIncomingTermVisaModal') viewIncomingTermVisaModal: TemplateRef<any>;
    incomingTermVisaSettings: any;
    errorMessage: string;
    dtTrigger: Subject<string> = new Subject();
    dtOptions: DataTables.Settings = {};
    public modalReference: NgbModalRef;
    editIncomingTermVisaSettingsFlag: boolean = false;
    modalTitle: string = '';
    selectUndefinedOptionValue: any = undefined;


    incomingTerms: any[] = [];
    academicYears: any[] = [];
    availableIncomingTerms: any[] = [];

    isLoading: boolean = false;
    isEditLoading: boolean = false;
    isAddLoading: boolean = false;
    isViewLoading: boolean = false;

    incomingTermsForAdd: any;
    academicYearsForAdd: any;
    academicYearsErrorMessage: string;
    selectedTerm: any;

    tableErrorMessage: string = '';
    modalErrorMessage: string = '';


    singleTerm: any = {};
    multiTerm: any = {};
    newTermSetting: any = {};

    constructor(
        private dmService: DataManagementService,
        private accessService: AccessService,
        private modal: NgbModal,
        private toastService: ToastrService,
          private router: Router,

    ) { }


    getIncomingTermVisaSettings(): void {
        this.isLoading = true;
        this.dmService.javaGetDataCall(Constants.GET_INCOMING_TERM_VISA_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.incomingTermVisaSettings = response.data;
                        if (this.incomingTermVisaSettings.length <= 0) {
                            this.errorMessage = 'There is no data available for incoming terms';
                        } else {
                            this.dtTrigger.next();
                        }
                        this.isLoading = false;

                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                    this.isLoading = false;

                    }
                },
                error => {
                    this.isLoading = false;
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    canAccessOIA() {
        return this.accessService.canAccessOIA();
    }

    getDateTime(dateTime): string {
        if (dateTime === undefined || dateTime === null || dateTime === '' || dateTime === 'undefined') {
            return '';
        }
        return moment(dateTime).format('Do MMM YYYY , hh:mm a');
    }

    getDate(timestamp: number | null | undefined): string {
        if (timestamp === null || timestamp === undefined || timestamp === 0) {
            return 'Not Set';
        }
        return moment(timestamp).format('Do MMM YYYY');
    }
    getDateFormat(timestamp: number | null | undefined): string {
        if (timestamp === null || timestamp === undefined || timestamp === 0) {
            return 'Not Set';
        }
        return moment(timestamp).format('YYYY MM dd');
    }


    getIsMutliterm(isMultiTerm: boolean): string {
        return isMultiTerm ? 'Yes' : 'No';
    }




    openAddIncomingTermVisaSettingModal(): void {
         this.isEditLoading = false;
        this.editIncomingTermVisaSettingsFlag = false; 

        this.newTermSetting = {
            incoming_term_id: this.selectUndefinedOptionValue
        };

                this.getIncomingTerms();


        this.availableIncomingTerms = this.incomingTermsForAdd || [];

        this.initializeTermObjects();

        this.modalReference = this.modal.open(this.addEditIncomingTermVisaSettingsModal, { size: 'lg', backdrop: 'static', keyboard: false });
    }

    openEditIncomingTermVisaSettingsModal(term: any): void {
        this.editIncomingTermVisaSettingsFlag = true;
        this.modalReference = this.modal.open(this.addEditIncomingTermVisaSettingsModal, { size: 'lg', backdrop: 'static', keyboard: false });
    }

    closeModal(): void {
        this.modalReference.close();
    }

    getIncomingTerms(): void {
        this.dmService.javaGetDataCall(Constants.INCOMING_TERM_SETTINGS)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.incomingTermsForAdd = response.data.incoming_terms;
                        this.availableIncomingTerms = this.incomingTermsForAdd || [];
                        this.academicYearsForAdd = response.data.academic_year;
                        if (this.incomingTermsForAdd.length <= 0) {
                            this.modalErrorMessage = 'There is no data available for incoming terms';
                        } else {
                            this.dtTrigger.next();
                        }
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.modalErrorMessage = response.message;
                        } else {
                            this.modalErrorMessage = 'Something went wrong. Please contact support team';
                        }
                    }
                },
                error => {
                    console.log(error);
                    this.modalErrorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    getIncomingTermsVisaSettings(): void {
        this.isLoading = true;
        this.dmService.javaGetDataCall(Constants.GET_INCOMING_TERM_SETTINGS_FOR_VISA)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.incomingTerms = response.data.incoming_terms;
                        this.academicYears = response.data.academic_year;
                        if (this.incomingTerms.length <= 0) {
                            this.errorMessage = 'There is no data available for incoming terms';
                        } else {
                            this.dtTrigger.next();
                        }
                        this.isLoading = false;
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.errorMessage = response.message;
                        } else {
                            this.errorMessage = 'Something went wrong. Please contact support team';
                        }
                        this.isLoading = false;
                    }
                },
                error => {
                    this.isLoading = false;
                    console.log(error);
                    this.errorMessage = 'Server Error';
                    // this.errorMessage = error;
                });
    }

    openViewIncomingTermModal(incomingTerm: any): void {
        this.selectedTerm = { ...incomingTerm };
        this.loadVisaSettingsForView(incomingTerm.incoming_term_id);

        this.modalReference = this.modal.open(this.viewIncomingTermVisaModal, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false
        });
    }

    private loadVisaSettingsForView(incomingTermId: any): void {
        this.isViewLoading = true;
        this.dmService.javaGetDataCallByParameter(Constants.GET_INCOMING_TERM_VISA_SETTINGS_BY_ID, incomingTermId)
            .subscribe(
                response => {
                    this.isViewLoading = false;
                    if (response.status === 'success' && response.data.length > 0) {

                        this.selectedTerm.singleTermSettings = response.data.find(item => !item.is_multi_term) || null;
                        this.selectedTerm.multiTermSettings = response.data.find(item => item.is_multi_term) || null;
                        this.selectedTerm.hasVisaSettings = true;
                        this.selectedTerm.hasSingleTerm = !!this.selectedTerm.singleTermSettings;
                        this.selectedTerm.hasMultiTerm = !!this.selectedTerm.multiTermSettings;
                        if (this.selectedTerm.singleTermSettings) {
                            this.selectedTerm.singleTermSettings.academic_year_id =
                                this.getAcademicYearIdByString(this.selectedTerm.singleTermSettings.academic_year);
                        }

                        if (this.selectedTerm.multiTermSettings) {
                            this.selectedTerm.multiTermSettings.academic_year_id =
                                this.getAcademicYearIdByString(this.selectedTerm.multiTermSettings.academic_year);
                        }

                    } else {

                        this.selectedTerm.singleTermSettings = null;
                        this.selectedTerm.multiTermSettings = null;
                        this.selectedTerm.hasVisaSettings = false;
                        this.selectedTerm.hasSingleTerm = false;
                        this.selectedTerm.hasMultiTerm = false;

                    }
                },
                error => {
                    this.isViewLoading = false;
                    this.selectedTerm.singleTermSettings = null;
                    this.selectedTerm.multiTermSettings = null;
                    this.selectedTerm.hasVisaSettings = false;
                    this.selectedTerm.hasSingleTerm = false;
                    this.selectedTerm.hasMultiTerm = false;


                }
            );
    }




    loadAvailableIncomingTerms(): void {
        this.availableIncomingTerms = this.incomingTermsForAdd || [];
    }

    isAnyTermValid(): boolean {
        const singleValid = this.isSingleTermValid();
        const multiPartiallyFilled = this.isMultiTermPartiallyFilled();

        return singleValid &&
            !multiPartiallyFilled &&
            this.newTermSetting.incoming_term_id &&
            this.newTermSetting.incoming_term_id !== this.selectUndefinedOptionValue;
    }

    private convertTimestampToDate(timestamp: number): string {
        if (!timestamp) return '';
        const date = new Date(timestamp);
        return date.toISOString().slice(0, 10);
    }

    openEditIncomingTermModal(incomingTerm: any): void {
        this.editIncomingTermVisaSettingsFlag = true;
         this.isEditLoading = true;
        this.newTermSetting = {
            incoming_term_id: incomingTerm.incoming_term_id
        };

        this.availableIncomingTerms = this.incomingTerms || [];

        this.initializeTermObjects();

        this.loadExistingVisaSettings(incomingTerm.incoming_term_id);

        this.modalReference = this.modal.open(this.addEditIncomingTermVisaSettingsModal, {
            size: 'lg',
            backdrop: 'static',
            keyboard: false
        });
    }

    private loadExistingVisaSettings(incomingTermId: any): void {
        this.isEditLoading = true;
        this.dmService.javaGetDataCallByParameter(Constants.GET_INCOMING_TERM_VISA_SETTINGS_BY_ID, incomingTermId)
            .subscribe(
                response => {
                    if (response.status === 'success' && response.data && response.data.length > 0) {
                        const singleTermData = response.data.find(item => !item.is_multi_term);
                        const multiTermData = response.data.find(item => item.is_multi_term);

                        if (singleTermData) {
                            this.singleTerm = Object.assign({}, singleTermData, {
                                arrival_date: this.convertTimestampToDate(singleTermData.arrival_date),
                                orientation_date: this.convertTimestampToDate(singleTermData.orientation_date),
                                registration_date: this.convertTimestampToDate(singleTermData.registration_date),
                                term_end_date: this.convertTimestampToDate(singleTermData.term_end_date),
                                t6_registration_date: this.convertTimestampToDate(singleTermData.t6_registration_date),
                                t6_term_end_date: this.convertTimestampToDate(singleTermData.t6_term_end_date),
                                academic_year_id: this.getAcademicYearIdByString(singleTermData.academic_year)

                            }); 
                        } else {
                            this.initializeSingleTerm();
                        }

                        if (multiTermData) {
                            this.multiTerm = Object.assign({}, multiTermData, {
                                arrival_date: this.convertTimestampToDate(multiTermData.arrival_date),
                                orientation_date: this.convertTimestampToDate(multiTermData.orientation_date),
                                registration_date: this.convertTimestampToDate(multiTermData.registration_date),
                                term_end_date: this.convertTimestampToDate(multiTermData.term_end_date),
                                t6_registration_date: this.convertTimestampToDate(multiTermData.t6_registration_date),
                                t6_term_end_date: this.convertTimestampToDate(multiTermData.t6_term_end_date),
                                academic_year_id: this.getAcademicYearIdByString(multiTermData.academic_year)

                            });
                        } else {
                            this.initializeMultiTerm();
                        }
                        this.isEditLoading = false;
                    } else {
                        this.initializeTermObjects();
                        this.isEditLoading = false;
                    }
                },
                error => {
                    this.isEditLoading = false;
                    console.error('Error loading existing visa settings:', error);
                    this.initializeTermObjects();
                }
            );
    }

    private getAcademicYearIdByString(academicYearString: string): number | null {
        if (!academicYearString || !this.academicYears) {
            return null;
        }

        const academicYear = this.academicYears.find(year => year.academic_year === academicYearString);
        return academicYear ? academicYear.academic_year_id : null;
    }
    private initializeSingleTerm(): void {
        this.singleTerm = {
            setting_id: null,
            incoming_term_id: this.newTermSetting.incoming_term_id || this.selectUndefinedOptionValue,
            term_name: '',
            term_duration: '',
            is_multi_term: false,
            letter_date: '',
            course_bidding_time: '',
            arrival_date: '',
            orientation_date: '',
            registration_date: '',
            term_end_date: '',
            t6_registration_date: '',
            t6_term_end_date: '',
            fact_sheet_link: '',
            academic_year_id: null
        };
    }

    private initializeMultiTerm(): void {
        this.multiTerm = {
            setting_id: null,
            incoming_term_id: this.newTermSetting.incoming_term_id || this.selectUndefinedOptionValue,
            term_name: '',
            term_duration: '',
            is_multi_term: true,
            letter_date: '',
            course_bidding_time: '',
            arrival_date: '',
            orientation_date: '',
            registration_date: '',
            term_end_date: '',
            t6_registration_date: '',
            t6_term_end_date: '',
            fact_sheet_link: '',
            academic_year_id: null
        };
    }

    private initializeTermObjects(): void {
        this.initializeSingleTerm();
        this.initializeMultiTerm();
    }

    saveTermSettings(): void {
        const singleValid = this.isSingleTermValid();
        const multiValid = this.isMultiTermValid();

        if (!singleValid && !multiValid) {
            this.toastService.warning('Please fill in at least the Single Term fields completely to save.', 'No Valid Data');
            return;
        }

        if (this.isSingleTermPartiallyFilled()) {
            const missingFields = this.getMissingSingleTermFields();
            this.toastService.warning(`Single Term incomplete. Please fill: ${missingFields.join(', ')}`, 'Incomplete Form');
            return;
        }

        if (this.isMultiTermPartiallyFilled()) {
            const missingFields = this.getMissingMultiTermFields();
            this.toastService.warning(`Multi Term incomplete. Please fill: ${missingFields.join(', ')}`, 'Incomplete Form');
            return;
        }

        if (!singleValid) {
            this.toastService.warning('Single Term configuration is mandatory. Please complete all Single Term fields.', 'Missing Required Data');
            return;
        }
        const payload = {
            incoming_term_id: this.newTermSetting.incoming_term_id,
            user_id: JSON.parse(localStorage.getItem("epas_user")).user_id,
            single_term: null,
            multi_term: null
        };

        payload.single_term = this.prepareSingleTermData();

        if (multiValid) {
            payload.multi_term = this.prepareMultiTermData();
        }

        const apiEndpoint = this.editIncomingTermVisaSettingsFlag
            ? Constants.UPDATE_INCOMING_TERM_VISA_SETTING
            : Constants.ADD_INCOMING_TERM_VISA_SETTING;

            this.isAddLoading = true;
        this.dmService.javaPostDataCall(payload, apiEndpoint)
            .subscribe(
                response => {
                    if (response.status === 'success') {
                        this.toastService.success('Term settings saved successfully', 'Success');
                        this.isAddLoading = false;

                        this.closeModal();
                        this.router.navigateByUrl('/RefreshComponent', {skipLocationChange: true}).then(() =>
                        this.router.navigate(['term-schedule/incoming-term-visa-settings']));
                       // this.getIncomingTermsVisaSettings();
                    } else if (response.status === 'fail') {
                        if (response.hasOwnProperty('message') && response.message !== null) {
                            this.modalErrorMessage = response.message;
                            this.toastService.error(this.modalErrorMessage, 'Error');
                            this.isAddLoading = false;
                        } else {
                            this.modalErrorMessage = 'Something went wrong. Please contact support team';
                            this.toastService.error(this.modalErrorMessage, 'Error');
                            this.isAddLoading = false;
                        }
                    } else {
                        this.toastService.error('Error saving term settings', 'Error');
                        this.isAddLoading = false;
                    }
                },
                error => {
                    this.toastService.error('Error occurred while saving', 'Error');
                    this.isAddLoading = false;
                }
            );
    }

    private prepareSingleTermData(): any {
        return {
            setting_id: this.singleTerm.setting_id, 
            term_name: this.singleTerm.term_name,
            term_duration: this.singleTerm.term_duration,
            is_multi_term: false,
            letter_date: this.singleTerm.letter_date,
            course_bidding_time: this.singleTerm.course_bidding_time,
            arrival_date: new Date(this.singleTerm.arrival_date),
            orientation_date: new Date(this.singleTerm.orientation_date),
            registration_date: new Date(this.singleTerm.registration_date),
            term_end_date: new Date(this.singleTerm.term_end_date),
            t6_registration_date: this.singleTerm.t6_registration_date && this.singleTerm.t6_registration_date.trim() !== ''
                ? new Date(this.singleTerm.t6_registration_date)
                : null,
            t6_term_end_date: this.singleTerm.t6_term_end_date && this.singleTerm.t6_term_end_date.trim() !== ''
                ? new Date(this.singleTerm.t6_term_end_date)
                : null,
            academic_year_id: this.singleTerm.academic_year_id ? parseInt(this.singleTerm.academic_year_id, 10) : null,
            fact_sheet_link: this.singleTerm.fact_sheet_link || '' 

        };
    }

    private prepareMultiTermData(): any {
        return {
            setting_id: this.multiTerm.setting_id, 
            term_name: this.multiTerm.term_name,
            term_duration: this.multiTerm.term_duration,
            is_multi_term: true,
            letter_date: this.multiTerm.letter_date,
            course_bidding_time: this.multiTerm.course_bidding_time,
            arrival_date: new Date(this.multiTerm.arrival_date),
            orientation_date: new Date(this.multiTerm.orientation_date),
            registration_date: new Date(this.multiTerm.registration_date),
            term_end_date: new Date(this.multiTerm.term_end_date),
            t6_registration_date: new Date(this.multiTerm.t6_registration_date),
            t6_term_end_date: new Date(this.multiTerm.t6_term_end_date),
            academic_year_id: this.multiTerm.academic_year_id ? parseInt(this.multiTerm.academic_year_id, 10) : null,
            fact_sheet_link: this.multiTerm.fact_sheet_link || ''

        };
    }


    private hasAnyMultiTermData(): boolean {
        const fields = [
            this.multiTerm.term_name,
            this.multiTerm.term_duration,
            this.multiTerm.letter_date,
            this.multiTerm.course_bidding_time,
            this.multiTerm.arrival_date,
            this.multiTerm.orientation_date,
            this.multiTerm.registration_date,
            this.multiTerm.term_end_date,
            this.multiTerm.t6_registration_date,
            this.multiTerm.t6_term_end_date,
            this.multiTerm.academic_year_id
        ];

        return fields.some(field => field && field.toString().trim() !== '' && field !== this.selectUndefinedOptionValue);
    }

    private hasAnySingleTermData(): boolean {
        const fields = [
            this.singleTerm.term_name,
            this.singleTerm.term_duration,
            this.singleTerm.letter_date,
            this.singleTerm.course_bidding_time,
            this.singleTerm.arrival_date,
            this.singleTerm.orientation_date,
            this.singleTerm.registration_date,
            this.singleTerm.term_end_date,
            this.singleTerm.academic_year_id
        ];

        return fields.some(field => field && field.toString().trim() !== '' && field !== this.selectUndefinedOptionValue);
    }

    isSingleTermValid(): boolean {
        if (!this.hasAnySingleTermData()) {
            return false;
        }

        const requiredFields = [
            this.singleTerm.term_name,
            this.singleTerm.term_duration,
            this.singleTerm.letter_date,
            this.singleTerm.course_bidding_time,
            this.singleTerm.arrival_date,
            this.singleTerm.orientation_date,
            this.singleTerm.registration_date,
            this.singleTerm.term_end_date,
            this.singleTerm.academic_year_id,
            this.singleTerm.fact_sheet_link
        ];

        return requiredFields.every(field => field && field.toString().trim() !== '' && field !== this.selectUndefinedOptionValue);
    }

    isMultiTermValid(): boolean {
        if (!this.hasAnyMultiTermData()) {
            return false;
        }
        const requiredFields = [
            this.multiTerm.term_name,
            this.multiTerm.term_duration,
            this.multiTerm.letter_date,
            this.multiTerm.course_bidding_time,
            this.multiTerm.arrival_date,
            this.multiTerm.orientation_date,
            this.multiTerm.registration_date,
            this.multiTerm.term_end_date,
            this.multiTerm.academic_year_id,
            this.multiTerm.fact_sheet_link
        ];

        return requiredFields.every(field => field && field.toString().trim() !== '' && field !== this.selectUndefinedOptionValue);
    }

    isMultiTermPartiallyFilled(): boolean {
        return this.hasAnyMultiTermData() && !this.isMultiTermValid();
    }

    isSingleTermPartiallyFilled(): boolean {
        return this.hasAnySingleTermData() && !this.isSingleTermValid();
    }

    getMissingMultiTermFields(): string[] {
        if (!this.hasAnyMultiTermData()) return [];

        const fieldLabels = {
            term_name: 'Term Name',
            term_duration: 'Term Duration',
            letter_date: 'Letter Date',
            course_bidding_time: 'Course Bidding Time',
            arrival_date: 'Arrival Date',
            orientation_date: 'Orientation Date',
            registration_date: 'Registration Date',
            term_end_date: 'Term End Date',
            t6_registration_date: 'T6 Registration Date',
            t6_term_end_date: 'T6 Term End Date',
            academic_year_id: 'Academic Year'
        };

        const missingFields = [];

        for (const [field, label] of Object.entries(fieldLabels)) {
            const value = this.multiTerm[field];
            if (!value || value.toString().trim() === '' || value === this.selectUndefinedOptionValue) {
                missingFields.push(label);
            }
        }

        return missingFields;
    }

    getMissingSingleTermFields(): string[] {
        if (!this.hasAnySingleTermData()) return [];

        const fieldLabels = {
            term_name: 'Term Name',
            term_duration: 'Term Duration',
            letter_date: 'Letter Date',
            course_bidding_time: 'Course Bidding Time',
            arrival_date: 'Arrival Date',
            orientation_date: 'Orientation Date',
            registration_date: 'Registration Date',
            term_end_date: 'Term End Date',
            academic_year_id: 'Academic Year'
        };

        const missingFields = [];

        for (const [field, label] of Object.entries(fieldLabels)) {
            const value = this.singleTerm[field];
            if (!value || value.toString().trim() === '' || value === this.selectUndefinedOptionValue) {
                missingFields.push(label);
            }
        }

        return missingFields;
    }

   
    ngOnInit() {
        // this.getIncomingTermVisaSettings();
        this.getIncomingTermsVisaSettings();
        this.dtOptions = {
            paging: true,
            retrieve: true,
            destroy: true,
            lengthChange: true,
            info: false
        };
    }

}
